import type { Component, JSX } from 'solid-js';
import { onMount } from 'solid-js';
import { shimmer } from '~/shared/lib/motion';

export interface SkeletonProps extends JSX.HTMLAttributes<HTMLDivElement> {
  shape?: 'box' | 'text' | 'circle';
  width?: string;
  height?: string;
}

export const Skeleton: Component<SkeletonProps> = (props) => {
  let ref: HTMLDivElement | undefined;
  onMount(() => {
    if (ref) shimmer(ref);
  });

  const shape = () => props.shape ?? 'box';
  const radius = () => (shape() === 'circle' ? 'rounded-full' : shape() === 'text' ? 'rounded-[6px]' : 'rounded-[10px]');
  const sizeStyle = (): JSX.CSSProperties => ({
    width: props.width,
    height: props.height ?? (shape() === 'text' ? '14px' : undefined),
    'aspect-ratio': shape() === 'circle' ? '1 / 1' : undefined,
  });

  return (
    <div
      ref={ref}
      aria-hidden="true"
      class={`shimmer-bg ${radius()} ${props.class ?? ''}`}
      style={{ ...(sizeStyle() as JSX.CSSProperties), ...(props.style as JSX.CSSProperties) }}
    />
  );
};
